export const ServerErrors = {
  505: 'Something went wrong please try again!',
  101: 'Unknown error has occured',
};

export const GeolocationsErrors = {
  access_denied:
    'Your browser denied the request for your current location. Please enable Location Services and reload the page.',
  location_unavailable:
    'Location information is unavailable. \nPlease clear cookies and try again.',
  timeout: 'The request to get user location timed out.',
  unknown_error: 'An unknown error occurred.',
};



// WEBPACK FOOTER //
// ./src/util/Errors.js